exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pika-lendar {\n    width: 600px !important;\n}\n", ""]);

// exports
